import { ComponentProps, ReactElement } from 'react';
import AsyncSelect from 'lib/AsyncSelect';
import { UsePageFilters } from 'store/pagesFilters/types';
import { CodeNameModel } from 'components/common/types';
import { useLoadLookup } from '../useLoadLookup';
import FilterAsyncLookup from '../FilterAsyncLookup';

export interface FilterAdminPersonProps
  extends Omit<ComponentProps<typeof AsyncSelect>, 'loadData' | 'onSelect' | 'selectedValue' | 'name' | 'textKey'> {
  changeFilters: UsePageFilters<AdminPersonFilterModel>['changeFilters'];
  adminPerson?: CodeNameModel;
}

export interface AdminPersonFilterModel {
  adminPerson: CodeNameModel;
}

const FilterAdminPerson = ({ changeFilters, adminPerson }: FilterAdminPersonProps): ReactElement => {
  const { onLoadAdminPerson } = useLoadLookup();

  return (
    <FilterAsyncLookup
      filterKey="adminPerson"
      selectedValue={adminPerson}
      loadData={onLoadAdminPerson}
      changeFilters={changeFilters}
      placeholder="Search admin person"
      dataTestId="adminPerson-filter"
      pendoLabel="Admin person filter"
    />
  );
};

export default FilterAdminPerson;
